import React from "react";
import { BsSliders } from "react-icons/bs";
import { longDateString } from "../../utils";
import EntityEmptyState from "../../components/EntityEmptyState";
import { EMPTY_MESSAGES } from "../../constants/emptyStateMessages";
import "../../starek.css";

const DeviceProfilesCardView = ({
    profiles = [],
    selectedRows = [],
    onSelectedRowsChange = () => {},
    onEdit = () => {},
    onDelete = () => {},
    onConfigure = () => {},
    onAdd,
    onRowClicked,
    onToggleActive,
    togglingActiveId,
}) => {
    const isProfileSelected = (profileId) => {
        return selectedRows.some((p) => p.id === profileId);
    };

    const handleCheckboxChange = (profile) => {
        let newSelectedRows;
        if (isProfileSelected(profile.id)) {
            newSelectedRows = selectedRows.filter((p) => p.id !== profile.id);
        } else {
            newSelectedRows = [...selectedRows, profile];
        }
        onSelectedRowsChange({ selectedRows: newSelectedRows });
    };

    if (profiles.length === 0) {
        return (
            <EntityEmptyState
                icon="fa-sd-card"
                entityName="Device Profile"
                messages={EMPTY_MESSAGES.deviceProfiles}
                isFiltered={false}
                onAdd={onAdd}
            />
        );
    }

    return (
        <div className="row g-3">
            {profiles.map((profile) => (
                <div key={profile.id} className="col-lg-3 col-md-4 col-sm-6">
                    <div
                        className={`card h-100 shadow-sm ${
                            isProfileSelected(profile.id)
                                ? "border-primary border-2"
                                : ""
                        }`}
                        style={{ cursor: "pointer", opacity: profile.is_active === false ? 0.55 : 1 }}
                        onClick={() => onRowClicked?.(profile)}
                    >
                        <div className="card-header bg-primary text-white">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center flex-grow-1">
                                    <div className="form-check mb-0 me-2" onClick={(e) => e.stopPropagation()}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={isProfileSelected(
                                                profile.id
                                            )}
                                            onChange={() =>
                                                handleCheckboxChange(profile)
                                            }
                                            onClick={(e) => e.stopPropagation()}
                                            aria-label={`Select ${profile.name}`}
                                        />
                                    </div>
                                    <h5
                                        className="card-title mb-0 text-truncate"
                                        title={profile.name}
                                    >
                                        {profile.name}
                                    </h5>
                                </div>
                                <div className="d-flex gap-1" onClick={(e) => e.stopPropagation()}>
                                    {onToggleActive && (
                                        <button
                                            className={`btn btn-sm ${profile.is_active ? "btn-outline-light" : "btn-outline-warning"}`}
                                            style={{ width: 32, height: 32, padding: 0 }}
                                            title={profile.is_active ? "Deactivate" : "Restore"}
                                            disabled={togglingActiveId === profile.id}
                                            onClick={() => onToggleActive(profile)}
                                        >
                                            {togglingActiveId === profile.id
                                                ? <span className="spinner-border spinner-border-sm" />
                                                : <i className={`fa ${profile.is_active ? "fa-ban" : "fa-undo"}`} />}
                                        </button>
                                    )}
                                    <button
                                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                                        style={{ width: "32px", height: "32px", padding: 0 }}
                                        onClick={(e) => { e.stopPropagation(); onConfigure(profile); }}
                                        title="Run Configurator"
                                    >
                                        <BsSliders />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body d-flex flex-column">
                            {/* Model Image and Name */}
                            {profile.configuration?.model && (
                                <div className="mb-3 d-flex align-items-start">
                                    <div
                                        style={{ width: "80px", flexShrink: 0 }}
                                    >
                                        <img
                                            src={
                                                profile.configuration.model
                                                    .image
                                            }
                                            alt={
                                                profile.configuration.model.name
                                            }
                                            className="img-fluid"
                                            style={{
                                                width: "100%",
                                                objectFit: "contain",
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = "none";
                                            }}
                                        />
                                    </div>
                                    <div className="ms-3 flex-grow-1">
                                        <div className="mb-1">
                                            <span className="badge bg-secondary text-wrap">
                                                {
                                                    profile.configuration.model
                                                        .name
                                                }
                                            </span>
                                        </div>
                                        <p
                                            className="text-muted mb-0"
                                            style={{ fontSize: "0.875rem" }}
                                        >
                                            {profile.description ||
                                                "No description"}
                                        </p>
                                    </div>
                                </div>
                            )}
                            {!profile.configuration?.model && (
                                <p
                                    className="text-muted mb-3 flex-grow-1"
                                    style={{ fontSize: "0.875rem" }}
                                >
                                    {profile.description || "No description"}
                                </p>
                            )}
                            <div className="border-top pt-2 mt-auto">
                                <small className="text-muted d-block">
                                    <i className="fas fa-user me-1"></i>
                                    {profile.updated_by?.name || "Unknown"}
                                </small>
                                <small className="text-muted d-block mt-1">
                                    <i className="fas fa-clock me-1"></i>
                                    {longDateString(profile.updated_at)}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default DeviceProfilesCardView;
